import React from "react";
import ImageCard from "../ImageCard";
import karraImage from "./../../images/karra.png";
import utombordareImage from "./../../images/utombordare2.png";
import bordImage from "./../../images/bord.png";
import cyklonImage from "./../../images/cyklon.png";
import hjulImage from "./../../images/hjul.jpg";
import trappaImage from "./../../images/trappa.jpg";
import framvagnImage from "./../../images/framvagn.png";
import maladeStaendeImage from "./../../images/malade_staende.jpg";
import maladeHangandeImage from "./../../images/malade_hangande.jpg";
export const Blog = () => {
  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h1 style={{ fontSize: "2.5rem", marginBottom: "20px", color: "#004d66" }}>
       Exempel på några av våra tidigare projekt
      </h1>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
        }}
      >
        <ImageCard
          imageSrc={framvagnImage}
          altText="Framvagn"
          caption="Stativ för demonstrering av framvagn till Volvo"
        />
        <ImageCard
          imageSrc={karraImage}
          altText="Kärra"
          caption="Specialbyggd kärra"
        />
        <ImageCard
          imageSrc={utombordareImage}
          altText="Utombordare"
          caption="Stativ för utombordare"
        />
        <ImageCard
          imageSrc={bordImage}
          altText="Bord"
          caption="Udelningsbord för postudelning till Postnord"
        />
        <ImageCard
          imageSrc={cyklonImage}
          altText="Cyklon"
          caption="Cyklon för utsug av pulverlack"
        />
        <ImageCard
          imageSrc={hjulImage}
          altText="Hjul"
          caption="Pulverlackering av hjul"
        />
        <ImageCard
          imageSrc={trappaImage}
          altText="Trappa"
          caption="Speciallbyggd trappa"
        />
        <div
          style={{
            margin: "20px",
            textAlign: "center",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            overflow: "hidden",
            backgroundColor: "#ffffff",
            maxWidth: "300px",
            minHeight: "400px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "10px", height: "400px", overflow: "hidden" }}>
            <img
              src={maladeStaendeImage}
              alt="Målad stående"
              style={{ width: "80%", height: "auto", borderRadius: "4px", transform: "rotate(90deg)", margin: "0 auto" }}
            />
            <img
              src={maladeHangandeImage}
              alt="Målad hängande"
              style={{ width: "8  0%", height: "auto", borderRadius: "4px", transform: "rotate(90deg)", margin: "0 auto" }}
            />
          </div>
          <div style={{ padding: "10px" }}>
            <p style={{ fontSize: "1rem", color: "#004d66" }}>Pulverlackerade handtag för kollektiv trafik</p>
          </div>
        </div>
      </div>
    </div>
  );
};